"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameList = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const design_card_game_card_1 = require("@unboared/design.card.game_card");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const GameList = ({ games, activeGame, size = 100, style }) => {
    const flatListRef = (0, react_1.useRef)();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const normalizedSize = normalize(size);
    const itemStyles = { padding: 0.1 * normalizedSize, marginRight: 0.05 * normalizedSize };
    (0, react_1.useEffect)(() => {
        if (activeGame) {
            let index = games.findIndex((game) => game.short === activeGame);
            flatListRef.current.scrollToIndex({ animated: true, index });
        }
    }, [activeGame]);
    return (react_1.default.createElement(react_native_1.FlatList, { ref: flatListRef, style: style, data: games, renderItem: ({ item }) => react_1.default.createElement(design_card_game_card_1.GameCard, Object.assign({}, item, { active: item.short == activeGame, size: size, style: itemStyles })), keyExtractor: item => item.short, horizontal: true, showsVerticalScrollIndicator: false, showsHorizontalScrollIndicator: false }));
};
exports.GameList = GameList;
//# sourceMappingURL=game_list.js.map